export const CMSPageTypeValues = ['blocksPage'] as const;

export type CMSPageType = (typeof CMSPageTypeValues)[number];
